export default __webpack_public_path__ + "static/media/msf_grid_xl.3df298ff.jpg";